import React from "react";
import { RiUserSearchFill } from "react-icons/ri";
import {
  LineStyle,
  Timeline,
  TrendingUp,
  PermIdentity,
  Storefront,
  AttachMoney,
  BarChart,
  MailOutline,
  DynamicFeed,
  ChatBubbleOutline,
  WorkOutline,
  Report,
} from "@material-ui/icons";
import { Link } from "react-router-dom";
import "./Sidebar.css";
import { InboxOutlined, SendOutlined } from "@ant-design/icons";

export default function SidebarMessages() {
  const username = localStorage.getItem("yourusername");
  return (
    <div className="sidebar">
      <div className="sidebarWrapper">
        <div className="sidebarMenu menu">
          {/* <h3 className="sidebarTitle menuItem uno">
            Welcome Admin {username}
          </h3> */}

          <ul className="sidebarList">
            <Link to="/Inbox" className="link ">
              <li className="sidebarListItem">
                <InboxOutlined className="sidebarIcon" /> Inbox
              </li>
            </Link>
          </ul>
          <ul className="sidebarList">
            <Link to="/Sent" className="link ">
              <li className="sidebarListItem">
                <SendOutlined className="sidebarIcon" /> Sent
              </li>
            </Link>
          </ul>
          <ul className="sidebarList">
            <Link to="/Draft" className="link ">
              <li className="sidebarListItem">
                <ChatBubbleOutline className="sidebarIcon" />
                Draft
              </li>
            </Link>
          </ul>
          <ul className="sidebarList">
            <Link to="/CreateMessage" className="link ">
              <li className="sidebarListItem">
                <ChatBubbleOutline className="sidebarIcon" />
                Create Message
              </li>
            </Link>
          </ul>
        </div>
        {/* <div className="sidebarMenu">
          <h3 className="sidebarTitle">Quick Menu</h3>
          <ul className="sidebarList">
            <Link to="/users" className="link">
              <li className="sidebarListItem">
                <PermIdentity className="sidebarIcon" />
                Users
              </li>
            </Link>
            <Link to="/products" className="link">
              <li className="sidebarListItem">
                <Storefront className="sidebarIcon" />
                Products
              </li>
            </Link>
            <li className="sidebarListItem">
              <AttachMoney className="sidebarIcon" />
              Transactions
            </li>
            <li className="sidebarListItem">
              <BarChart className="sidebarIcon" />
              Reports
            </li>
          </ul>
        </div>
        <div className="sidebarMenu">
          <h3 className="sidebarTitle">Notifications</h3>
          <ul className="sidebarList">
            <li className="sidebarListItem">
              <MailOutline className="sidebarIcon" />
              Mail
            </li>
            <li className="sidebarListItem">
              <DynamicFeed className="sidebarIcon" />
              Feedback
            </li>
            <li className="sidebarListItem">
              <ChatBubbleOutline className="sidebarIcon" />
              Messages
            </li>
          </ul>
        </div>
        <div className="sidebarMenu">
          <h3 className="sidebarTitle">Staff</h3>
          <ul className="sidebarList">
            <li className="sidebarListItem">
              <WorkOutline className="sidebarIcon" />
              Manage
            </li>
            <li className="sidebarListItem">
              <Timeline className="sidebarIcon" />
              Analytics
            </li>
            <li className="sidebarListItem">
              <Report className="sidebarIcon" />
              Reports
            </li>
          </ul>
        </div> */}
      </div>
    </div>
  );
}
